<script setup lang="ts">
import { api } from '@/api'
import { ref } from 'vue'
import { RouterView, useRouter, useRoute } from 'vue-router'

const statuses = ref<string[]>([])
const router = useRouter()
const route = useRoute()

const init = async () => {
  statuses.value = await api.prompts.list()
}

const handleTabChange = (tabName: string) => {
  router.push({ name: 'prompt', params: { status: tabName } })
}

init()
</script>

<template>
  <main>
    <h2>Prompts</h2>

    <el-tabs
      :model-value="route.params.status as string"
      @tab-change="handleTabChange"
      class="prompts-tabs"
    >
      <el-tab-pane v-for="prompt in statuses" :key="prompt" :label="prompt" :name="prompt" />
    </el-tabs>

    <RouterView />
  </main>
</template>

<style scoped>
.prompts-tabs {
  margin-bottom: 20px;
}
</style>
